<div class="validation-errors-container">
    <div *ngIf="loading" class="loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <div class="validation-errors-wrapper" *ngIf="validationErrors?.length > 0">
        <div class="header-wrapper">
            <div class="titles-wrapper">
                <div class="title">
                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.title' |translate}}
                </div>
                <div class="sub-title">
                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.sub-title' |translate}}
                </div>
            </div>
            <div class="download-errors-wrapper">
                <button [disabled]="validationErrors?.length === 0" class="btn btn-template" (click)="downloadErrors()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                        <path
                            d="M2.375 13.5625V15.3438C2.375 15.8162 2.56267 16.2692 2.89672 16.6033C3.23077 16.9373 3.68383 17.125 4.15625 17.125H14.8438C15.3162 17.125 15.7692 16.9373 16.1033 16.6033C16.4373 16.2692 16.625 15.8162 16.625 15.3438V13.5625M13.0625 10L9.5 13.5625M9.5 13.5625L5.9375 10M9.5 13.5625V2.875"
                            stroke="#0074EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.download-btn' |translate}}
                </button>
            </div>
        </div>
        <div class="metrics-wrapper">
            <div class="not-enrolled-metric">
                <div class="title">
                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.not-enrolled' |translate}}
                </div>
                <div class="value not-enrolled-num">
                    {{originalErrorsLength |arabicNumber:lang}}
                </div>
            </div>
        </div>
    </div>

    <div class="fix-errors-wrapper" [ngStyle]="{'margin-top': validationErrors?.length > 0 ? '32px' : '0px'}">
        <div class="body">
            <!-- card info section -->
            <div class="card-info-section" *ngIf="validationErrors?.length > 0">
                <div class="header">
                    <span class="title">
                        {{'buses.bulk-enroll.fix-errors-step.validation-errors.student-not-enrolled' |translate}}
                    </span>
                    <div class="progress-wrapper">
                        <div class="percentage">{{progressLocalization(progress)}}%</div>
                        <mat-progress-bar *ngIf="progress !== undefined" mode="determinate" [value]="progress">
                        </mat-progress-bar>
                    </div>
                </div>
                <div class="body">
                    <div class="cards-wrapper">
                        <div class="card-info" *ngFor="let infoCard of validationErrors, index as rowIndex "
                            (click)="selectError(infoCard , false)" [class.selected]="infoCard?.selected">
                            <span class="name">
                                {{'buses.bulk-enroll.fix-errors-step.validation-errors.student-id' |translate}}:
                                {{infoCard?.original_student_id}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- card details section -->
            <div class="card-datails-bulk-actions-wrapper" *ngIf="validationErrors?.length > 0">
                <div class="card-details-section">
                    <div class="error-wrapper" *ngFor="let error of validationErrors, index as errorIndex ">
                        <div class="error-content" *ngIf="error.selected">
                            <div class="body">
                                <div class="student-section">
                                    <div class="title">
                                        {{'buses.bulk-enroll.fix-errors-step.validation-errors.students-details'
                                        |translate}}:
                                    </div>
                                    <!-- student id -->
                                    <div class="error-row">
                                        <!-- label -->
                                        <span class="label" [class.error]="error?.validation_errors?.student_id">
                                            {{'buses.bulk-enroll.fix-errors-step.validation-errors.student-id'
                                            |translate}}
                                        </span>

                                        <!-- field -->
                                        <input [class.inputError]="error?.validation_errors?.student_id"
                                            [(ngModel)]="error.student_id"
                                            (input)="clearFieldError(error, 'student_id')">

                                        <!-- errorMsg -->
                                        <span [class.error]="error?.validation_errors?.student_id"
                                            *ngIf="error?.validation_errors?.student_id ? true : false">
                                            {{lang == 'ar' ? error?.validation_errors?.student_id?.ar :
                                            error?.validation_errors?.student_id?.en}}
                                        </span>
                                    </div>
                                    <!-- trip id -->
                                    <div class="error-row">
                                        <!-- label -->
                                        <span class="label" [class.error]="error?.validation_errors?.trip_id">
                                            {{'buses.bulk-enroll.fix-errors-step.validation-errors.trip-number'
                                            |translate}}
                                        </span>

                                        <!-- field -->
                                        <input [class.inputError]="error?.validation_errors?.trip_id"
                                            [(ngModel)]="error.trip_id" (input)="clearFieldError(error, 'trip_id')">

                                        <!-- errorMsg -->
                                        <span [class.error]="error?.validation_errors?.trip_id"
                                            *ngIf="error?.validation_errors?.trip_id ? true : false">
                                            {{lang == 'ar' ? error?.validation_errors?.trip_id?.ar :
                                            error?.validation_errors?.trip_id?.en}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="header">
                                <button class="skip-error-btn" (click)="skipErrors('single', error, errorIndex)">
                                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.ignore-btn' |translate}}
                                </button>
                                <button (click)="selectError(error , true)">
                                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.save-btn' |translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="no-errors-container" *ngIf="validationErrors?.length == 0">
                <app-upload-progress-state [upload_state]="upload_state" [uploaded_data]="uploaded_data" [lang]="lang"
                    (showDetailsEvent)="showDetailsPopup()"></app-upload-progress-state>
            </div>

            <div class="bulk-actions-wrapper " [ngClass]="lang == 'en' ? 'bulk-ltr' : 'bulk-rtl' ">
                <button class="skip-error-btn" (click)="skipErrors('multiple')" *ngIf="validationErrors?.length > 0">
                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.ignore-all-btn' |translate}}
                </button>
                <button *ngIf="upload_state !='finshed-with-details'" class="btn" (click)="enroll()"
                    [disabled]="validationErrors?.length > 0 || upload_state == 'enroll-in-progress'">
                    {{'buses.bulk-enroll.fix-errors-step.validation-errors.enroll-btn' |translate}}
                </button>
            </div>
        </div>

    </div>

    <div class="details-popup-wrapper" *ngIf="show_details_popup">
        <div class="result-popup-modal">
            <!-- Close button -->
            <div class="close-icon" (click)="closeDetailsPopup()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>

            <div class="tabs-switcher">
                <div class="tab" [class.active]="activeTab === 'success'" (click)="activeTab = 'success'">
                    {{ 'buses.enroll-bus.enroll-details.sucessful-enrolment-title' | translate }}
                </div>
                <div class="tab" [class.active]="activeTab === 'failed'" (click)="activeTab = 'failed'">
                    {{ 'buses.enroll-bus.enroll-details.failed-enrollement-title' | translate }}
                </div>
            </div>
            <div class="tab-content">
                <ng-container *ngIf="activeTab === 'success'">
                    <div class="scrollable-content" *ngIf="successStudents?.length; else noSuccess">
                        <div class="student-row" *ngFor="let student of successStudents">
                            <div class="item">
                                <div class="label">
                                    {{'buses.enroll-bus.enroll-details.student-name' | translate}}
                                </div>
                                <span class="value">{{ student?.name }}</span>
                            </div>
                            <div class="item">
                                <div class="label">
                                    {{'buses.enroll-bus.enroll-details.national-id' | translate}}
                                </div>
                                <span class="value" data-pii="redact">{{ student?.national_id }}</span>
                            </div>
                            <div class="item">
                                <div class="label">
                                    {{'buses.enroll-bus.enroll-details.grade' | translate}}
                                </div>
                                <span class="value">{{ student?.class?.grade?.name }}</span>
                            </div>
                            <div class="item">
                                <div class="label">
                                    {{'buses.enroll-bus.enroll-details.class' | translate}}
                                </div>
                                <span class="value">{{ student?.class?.name }}</span>
                            </div>
                        </div>
                    </div>
                    <ng-template #noSuccess>
                        <div class="empty-message">
                            {{'buses.bulk-enroll.fix-errors-step.validation-errors.no-success-students' |translate}}
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="activeTab === 'failed'">
                    <div class="scrollable-content" *ngIf="failStudentsIds?.length; else noFailed">
                        <div class="student-row" *ngFor="let student of failStudentsIds">
                            <div class="item">
                                <div class="label">
                                    {{'buses.enroll-bus.enroll-details.national-id' | translate}}
                                </div>
                                <span class="student-name">{{ student }}</span>
                            </div>
                        </div>
                    </div>
                    <ng-template #noFailed>
                        <div class="empty-message">
                            {{'buses.bulk-enroll.fix-errors-step.validation-errors.no-failed-students' |translate}}
                        </div>
                    </ng-template>
                </ng-container>
            </div>

            <!-- Fixed button at bottom -->
            <div class="fixed-bottom-button">
                <button *ngIf="uploaded_data?.num_enrolled_students > 0" class="btn btn-primary" (click)="handleBottomButtonAction()">
                    {{'upload-progress-state.btns.next-step' |translate}}
                </button>
                <button *ngIf="uploaded_data?.num_enrolled_students == 0"  class="btn btn-primary" (click)="goBack($event)">{{'upload-progress-state.btns.back-to-students' |translate}}</button>
            </div>
        </div>
    </div>
</div>